module.exports = axios;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 20
// module chunks = 0 1 2 3 7 9